import { ActionResponseType } from "../../../common/types/common.types";
import { ApiClient } from "../../../core/api/apiClient.service";
import { QuestionnaireSummaryParameterDTO } from "./QuestionnaireSummaryPage.types";

const client = new ApiClient();

export const getQuestionnaireSummary = async (
  Params: QuestionnaireSummaryParameterDTO
): Promise<ActionResponseType> => {
  try {
    const URL: string = `QuestionnaireSummary/GetQuestionnaireSummary`;
    let data = {} as ActionResponseType;
    await client
      .post<ActionResponseType>(URL, Params)
      .then((response: ActionResponseType) => {
        data = response;
      })
      .catch((error) => {
        // console.log(error);
      });

    return data;
  } catch (error) {
    // console.log(error);
    throw error;
  }
};

export const reassess = async (
  Params: QuestionnaireSummaryParameterDTO
): Promise<ActionResponseType> => {
  try {
    const URL: string = `QuestionnaireSummary/Reassess`;
    let data = {} as ActionResponseType;
    await client
      .post<ActionResponseType>(URL, Params)
      .then((response: ActionResponseType) => {
        data = response;
      })
      .catch((error) => {
        // console.log(error);
      });

    return data;
  } catch (error) {
    // console.log(error);
    throw error;
  }
};
